import React, { useMemo } from 'react';
import { getComponentCssVariables } from '@wix/tpa-style-webpack-plugin/standalone';
import { InputBorderStyle } from '../constants';
const getInputBorderWidths = _ref => {
  var _styleParams$numbers, _styleParams$numbers2;
  let {
    styleParams
  } = _ref;
  const borderWidth = (styleParams == null || (_styleParams$numbers = styleParams.numbers) == null ? void 0 : _styleParams$numbers.inputBorderWidth) || 1;
  const borderStyle = (styleParams == null || (_styleParams$numbers2 = styleParams.numbers) == null ? void 0 : _styleParams$numbers2.inputBorderStyle) ?? 1;
  const defaultBorders = {
    '--inputBorderLeftWidth': borderWidth,
    '--inputBorderRightWidth': borderWidth,
    '--inputBorderTopWidth': borderWidth,
    '--inputBorderBottomWidth': borderWidth
  };
  const borders = {
    [InputBorderStyle.None]: {
      '--inputBorderLeftWidth': 0,
      '--inputBorderRightWidth': 0,
      '--inputBorderTopWidth': 0,
      '--inputBorderBottomWidth': 0
    },
    [InputBorderStyle.Bottom]: {
      '--inputBorderLeftWidth': 0,
      '--inputBorderRightWidth': 0,
      '--inputBorderTopWidth': 0,
      '--inputBorderBottomWidth': borderWidth
    },
    [InputBorderStyle.AllSides]: defaultBorders
  }[borderStyle];
  return borders;
};
export const FormTheme = _ref2 => {
  let {
    style,
    children,
    isMobile,
    disableTheme
  } = _ref2;
  const validStylesheet = style && style.styleParams && style.siteTextPresets && style.siteColors;
  const cssVars = useMemo(() => validStylesheet && getComponentCssVariables(style, {}, {}, {
    isMobile
  }, {}), [validStylesheet, style, isMobile]);
  const inputBorderWidths = getInputBorderWidths({
    styleParams: style == null ? void 0 : style.styleParams
  });
  if (!validStylesheet || !cssVars || disableTheme) {
    return /*#__PURE__*/React.createElement("div", null, children);
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      ...cssVars.variables,
      ...inputBorderWidths
    }
  }, children);
};
//# sourceMappingURL=form-theme.js.map